import React from 'react';
import styled from 'styled-components';

import { Layout, Menu, Icon, Tooltip } from 'antd';

import Content from '../../views/ResponsiveContent';
import Header from './../Header';
import { WHITE, GRAY, GRAY_JIRA, SELECTED_MENU_HIGHLIGHT_COLOR } from '../../views/styleConstants';
import NewWindowIcon from './../../views/NewWIndowIcon';
import Meta from '../Meta';

const { Sider } = Layout;

const StyledCopyright = styled.div`
  position: absolute;
  font-size: 11px;
  color: #999;
  bottom: 20px;
  width: 100%;
  text-align: center;
`;

const StyledButton = styled.button`
  background:none;
  border:none;
  margin:0;
  padding:0;
  cursor: pointer;
  &:focus{
    outline: none;
  }
`;

const SideMenu = styled(Sider)`
  height: 100%;
  padding: 0;
  background: ${GRAY_JIRA};
  .ant-menu {
    background: ${GRAY_JIRA};
  }
`;

const StyledMainView = styled(Layout)`
  .background {
    background: ${WHITE};
    &.dark{
      background: rgb(26, 43, 58);
    }
    &.less-dark {
      background: rgb(42, 69, 93)
    }
  }
  .page-title {
    color: #2e2e2e;
    font-size: 1.5em;
    margin: 0;
    opacity: 0.9;
  }
  .blue-icon {
    background: rgb(144, 202, 249);
  }
  .green-icon {
    background: rgb(165, 214, 167);
  }
  .title-text{
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
  }

  .content{
    minHeight: 280px;
    display: flex;
    position: relative;
    background-color: #fafafa;
  }
  
  .ant-layout {
    background-color: transparent;
  }
  
  .table-message { 
    text-align: right;
    margin-top: 5px;
    color: #a4a4a4d9;
  }

  .ant-layout-sider {
    position: relative;
  }
  .new-window-icon { 
    display: inline-block;
    position: relative;
    right: -5px;
    top: -5px;
    opacity: .5;
  }
  .footer{
    line-height: 40px;
    height: 40px;
    padding: 0 0 0 10px;
    text-align: left;
    color: #aaa;
  }
  .ant-menu-inline-collapsed {
    width: 60px;
     & > .ant-menu-item {
      padding: 0 0.5rem !important;
    }
  }
  .ant-layout-header {
    .ant-layout-header { 
      padding-left: 20px; 
      padding-right: 20px;
    }
    .sub-header {
      background-color: #d9d9d9;
    }
  }
  
  .main-menu .ant-menu { 
    background-color: #f4f4f4; 
    padding: 20px 0; 
    .ant-menu-item { 
      padding: 0 20px !important; 
      font-size: 1.2em; 
      color: rgba(0, 0, 0, 0.7); 
      &:hover { 
        color: rgb(0, 121, 191); 
      }
      &.ant-menu-item-selected::after { 
        border-right-width: 4px;
      }
    }
    .anticon, .ant-menu-submenu-title .anticon {
      font-size: 1.4em;
      position: relative;
      top: 4px;
      margin-right: 20px !important;
      color: #999999;
    }
  }
 
  .ant-menu-item-selected, .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: ${SELECTED_MENU_HIGHLIGHT_COLOR};
  }
  .voicebase-copyright { 
    color: #999999; 
  }
  .ant-layout-sider-collapsed {
    .expanded-copyright {
      display: none;
    }
    .collapsed-copyright {
      display: block;
    }
    .main-menu .ant-menu .ant-menu-item.ant-menu-item-selected::after {
      border-right-width: 2px;
    }
  }
  .collapsed-copyright {
    display: none;
    .copyright-symbol { font-size: 1.2em; }
  }
  .ant-tabs-extra-content {
    line-height: inherit;
    button {
      background-color: transparent;
      color: blue;
      &:hover {
        color: black;
       }
    }
  }
`;

const StyledNWI = styled.div`
  position: absolute; 
  right: 3px;
  top: 1px;
 `;

const MenuItem = styled(Menu.Item)`
  position: relative;
  padding: 0 0.5rem !important;
`;

const cleanStr = str => str.replace(/[^A-Z0-9]/ig, '_');

export default (bottle) => {
  /* eslint-disable react/prop-types */
  bottle.factory('MainView', () => ({
    history, menuSelection, children, onOpenWindow, pages, go, sidebarCollapsed, toggleSidebar, fullWidth
  }) => (
    <StyledMainView className="app">
      <Meta />
      <Layout style={{ height: '100%' }} className={`${fullWidth ? 'full-width': ''}`}>
        <Layout.Header theme="light" style={({ backgroundColor: 'white', padding: 0 })}>
          <Header toggleSidebar={toggleSidebar} />
        </Layout.Header>
        <Layout>
          <SideMenu width={250} collapsedWidth={60} breakpoint="lg" collapsed={sidebarCollapsed} className="main-menu">
            <Menu
              mode="inline"
              selectedKeys={[menuSelection]}
              defaultSelectedKeys={['1']}
              defaultOpenKeys={[]}
              style={{ height: '100%' }}
            >
              {
                pages.map(page => (
                  <MenuItem
                    data-type="MenuItem"
                    data-id={`menuItem-${cleanStr(page.name)}`}
                    key={page.key}
                    onClick={() => go(page)}
                  >
                    <span>
                      <Icon type={page.icon} />
                      {(page.link) ? (
                        <StyledButton>
                          {page.name}
                          {page.link && (
                            <StyledNWI className="new-window-icon">
                              <NewWindowIcon size="small" />
                            </StyledNWI>
                          )}
                        </StyledButton>
                    ) : page.name
                    }
                    </span>
                  </MenuItem>
                ))
              }
            </Menu>
            <StyledCopyright className="voicebase-copyright">
              <span className="collapsed-copyright" >
                <Tooltip title={(<span>&copy; {new Date().getUTCFullYear()} VoiceBase</span>)} placement="right">
                  <span className="copyright-symbol">&copy;</span>
                </Tooltip>
              </span>
              <span className="expanded-copyright" >&copy; <span>{new Date().getUTCFullYear()} VoiceBase</span></span>
            </StyledCopyright>
          </SideMenu>
          <Content>
            {children}
          </Content>
        </Layout>
      </Layout>

    </StyledMainView>
  ));
};
